// extracted by mini-css-extract-plugin
export default {"UploadSameName":"UploadSameName___J7Ns0"};